// Auth plugin.
import { reducer, name, api } from '../interface'

// Other plugins.
import { update as updateConfig } from '../../config/interface/actions'

// Libraries.
import { mergeValues } from '../../common/utils'
import { pick } from 'lodash/fp'
import { put } from 'redux-saga/effects'

/**
 * Basic auth plugin that has exposes no implementation.
 * For use with special case builds which don't use an auth plugin,
 *      but need to store authentication state.
 * @method baseAuth
 * @return {Object} A base authentication plugin.
 */
export default function baseAuth (options = {}) {
  const defaultOptions = {
    subscription: {
      expires: 3600,
      // Note: No default `service`.
      protocol: 'https',
      version: '1',
      port: '443'
    },
    websocket: {
      protocol: 'wss',
      port: '443'
    }
  }
  options = mergeValues(defaultOptions, options)

  function * init () {
    yield put(updateConfig(options, name))
  }

  // Modified auth API. Only exposes state getters.
  function noopAPI ({ dispatch, getState }) {
    const normalAPI = api({ dispatch, getState })

    // Auth APIs that only return state.
    const apiGetters = ['getUserInfo', 'getConnection', 'getServices']
    return pick(apiGetters, normalAPI)
  }

  return {
    name,
    reducer,
    init,
    api: noopAPI
  }
}
